import Vue from  'vue';

export default {

    data() {
        return {
            introState: 0
        }
    },

    props: {
        scrollY: { type: Number, default: 0 }
    },

    watch: {
        scrollY(scrollY)
        {
            if (this.introState < 1)
            {
                this._playIntro()
            }
        }
    },

    created() {
        if (this.$root.$children[0].support.touch)
        {
            this.introState = 2
        }
    },

    mounted() {

        this._videoTest = this.$el.querySelector('.c-video-intro')
    },

    methods: {

        _playIntro()
        {
            if (this._videoTest)
            {
                this.introState = 1
                this._videoTest.addEventListener('ended', event =>
                {
                    this.introState = 2
                })
                this._videoTest.play()
            }
        },
    }

}